// extracted by mini-css-extract-plugin
export default {"icon":"EmptyState_icon__WHbpd"};